import React from "react";

export default function Admin() {
  return (
    <iframe
      style={{
        height: "100vh",
        width: "100%",
        border: "none",
        position:"absolute",
        zIndex:"1000"
      }}
      src="https://live77-new-admin.netlify.app"
    />
  );
}
